'use client';

import React from 'react';
import ForgotPasswordPageContent from './components/ForgotPasswordPageContent';

export default function ForgotPasswordPage() {
  return <ForgotPasswordPageContent />;
}
